import { PropsWithChildren } from "react"
import { Card } from "@mui/material"
import { makeStyles } from "tss-react/mui"

const useStyles = makeStyles()((theme) => ({
    box: {
        border: `1px solid ${theme.palette.tailwind.slate[100]}`,
        borderRadius: ".75rem",
        boxShadow: "0px 2px 6px 0px rgba(0, 0, 0, 0.08)",

        display: "flex",
        flexDirection: "column",
        background: "white",
    },
    padding: {
        padding: "2rem",
    },
}))

type FormCardProps = Readonly<PropsWithChildren<{
    isPadding?: boolean
    className?: string
}>>

export function FormCard({
    children,
    isPadding = true,
    className,
}: FormCardProps) {
    const { classes, cx } = useStyles()
    return (
        <Card className={cx(classes.box, { [classes.padding]: isPadding }, className)}>
            {children}
        </Card>
    )
}
